export const CHANGE_PRODUCTION_QUEUE_VALUE = 'CHANGE_PRODUCTION_QUEUE_VALUE';
export const CHANGE_PRODUCTION_QUEUE_SEVERAL_VALUES = 'CHANGE_PRODUCTION_QUEUE_SEVERAL_VALUES';

export const RESET_PRODUCTION_QUEUE_STORE = 'RESET_PRODUCTION_QUEUE_STORE';
export const START_QUEUE_CONNECTION = 'START_QUEUE_CONNECTION';
export const SET_GRILLED_QUEUE_DATA = 'SET_GRILLED_QUEUE_DATA';
export const RESET_QUEUE_DATA = 'RESET_QUEUE_DATA';

export const changeValue = (key, value) => ({
  type: CHANGE_PRODUCTION_QUEUE_VALUE,
  payload: {
    key,
    value,
  },
});

export const changeSeveralValues = (value) => ({
  type: CHANGE_PRODUCTION_QUEUE_SEVERAL_VALUES,
  payload: value,
});

export const startQueueConnection = () => ({
  type: START_QUEUE_CONNECTION,
});

export const setGrilledQueueData = (value) => ({
  type: SET_GRILLED_QUEUE_DATA,
  payload: value,
});

export const resetData = () => ({
  type: RESET_QUEUE_DATA,
});

export const resetStore = () => ({
  type: RESET_PRODUCTION_QUEUE_STORE,
});
